import {
  DRAWER_TEXT_MAX_CHARS,
  isDrawerTextAllowed,
  normalizeDrawerText,
} from "@components/SideDrawer/SideDrawer.schema";
import { z } from "zod";

export const REASON_DIALOG_FIELDS = {
  REASON: "reason",
} as const;

// DFT-0027 (Slice A): mandatory-reason validation, expressed in zod and
// consolidated onto the shared drawer-text helpers
// (DRAWER_TEXT_MAX_CHARS / isDrawerTextAllowed / normalizeDrawerText) that
// replace the former local REASON_MAX_CHARS constant.
export const reasonDialogSchema = z.object({
  reason: z.string().superRefine((value, ctx) => {
    const trimmed = normalizeDrawerText(value);

    if (!trimmed) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "A reason is required.",
      });
      return;
    }

    if (trimmed.length > DRAWER_TEXT_MAX_CHARS) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Reason must be ${DRAWER_TEXT_MAX_CHARS} characters or fewer.`,
      });
    }

    if (!isDrawerTextAllowed(trimmed)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message:
          "Only letters, numbers, spaces, and these symbols: . , : ; ! ? ( ) _ @ # % & * ' - allowed",
      });
    }
  }),
});

export type ReasonDialogFormData = z.infer<typeof reasonDialogSchema>;

export const reasonDialogDefaultValues: ReasonDialogFormData = {
  reason: "",
};
